import axios from "axios";
import { translateApiError } from "@/api/apiErrorMessage";

export function extractReportErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const translated = translateApiError(err);
    if (translated) return translated;
    // Legacy tolerance: pre-ProblemDetails endpoints returned bare JSON strings.
    const data = err.response?.data;
    if (typeof data === "string" && data.trim().length > 0) return data;
    if (err.message) return `${fallback}: ${err.message}`;
  }
  if (err instanceof Error && err.message) return `${fallback}: ${err.message}`;
  return fallback;
}
